import React from "react";
import { AccordionComponent } from "../../../../CommonElements/Accordion";
import PermissionCheckbox from "../components/PermissionCheckbox";

export const renderPermissions = ({
  nodes,
  selectedPermissions,
  handlePermissionChange,
  handleParentChange,
  getAllPermissionIds,
  areAllChildrenSelected,
  areAnyChildrenSelected,
  control,
  mode = "form",
  level = 0,
  col = 12,
}) => {
  return nodes
    .map((node) => {
      const hasPermissions = node.permissions && node.permissions.length > 0;
      const hasChildren = node.children && node.children.length > 0;
      const permissionIds = Array.from(getAllPermissionIds(node));
      const childItems = hasChildren
        ? renderPermissions({
            nodes: node.children,
            selectedPermissions,
            handlePermissionChange,
            handleParentChange,
            getAllPermissionIds,
            areAllChildrenSelected,
            areAnyChildrenSelected,
            control,
            mode,
            level: level + 1,
            col,
          })
        : [];
      const hasRenderableChildren = childItems.length > 0;
      const allSelected = areAllChildrenSelected(node);
      const anySelected = areAnyChildrenSelected(node);
      const hasSelectablePermissions = permissionIds.length > 0;

      let content = null;

      if (hasPermissions) {
        const permissionsContent = (
          <div className="mb-3">
            {node.permissions.map((permission) => (
              <PermissionCheckbox
                key={permission?.id}
                permission={permission}
                isSelected={selectedPermissions.has(permission?.id)}
                onChange={(checked) =>
                  handlePermissionChange(permission?.id, checked)
                }
                control={control}
                mode={mode}
                className="d-flex align-items-center gap-2 mb-2"
              />
            ))}
          </div>
        );

        if (hasChildren) {
          content = (
            <div>
              {permissionsContent}
              <div className="mt-3">
                <AccordionComponent
                  className="nested-accordion"
                  items={childItems}
                />
              </div>
            </div>
          );
        } else {
          content = permissionsContent;
        }
      } else if (hasRenderableChildren) {
        content = (
          <AccordionComponent
            className="nested-accordion"
            items={childItems}
          />
        );
      } else {
        content = <div className="text-muted p-3"><small>No permissions in this section</small></div>;
      }

      if (!content) {
        return null;
      }

      return {
        id: node?.id.toString(),
        title: node.name_ar,
        className: level === 0 ? `col-md-${col}` : "w-100",
        content,
        showCheckbox: mode === "form",
        checked: hasSelectablePermissions ? allSelected : false,
        checkboxDisabled: !hasSelectablePermissions,
        indeterminate: hasSelectablePermissions && anySelected && !allSelected,
        onCheckboxChange:
          mode === "form" && hasSelectablePermissions
            ? (id, checked) => {
                handleParentChange(node, checked);
              }
            : undefined,
      };
    })
    .filter(Boolean);
};
